import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Link,
  Image,
  Badge,
  cn,
  Avatar,
} from "@nextui-org/react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@nextui-org/react";
import { addDays, format } from "date-fns";
import {
  collection,
  doc,
  getDoc,
  getFirestore,
  limit,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

//@ts-ignore
import sound from "../../../assets/sounds/buzzer-4.mp3";
import QRCode from "qrcode.react";

type RoomParams = {
  id: string;
};

type infoSolicitarPresenca = {
  sessao: {
    id: string;
    dataSessao: string;
    legislatura: string;
    periodo: string;
    sessao: string;
    statusConfigSessao: number;
    statusSessao: string;
    tipoSessao: string;
  };
};

export function GrandeExpediente({ sessao }: infoSolicitarPresenca) {
  const params = useParams<RoomParams>();
  const roomId = params.id;

  const audioRef = useRef(null);

  const [time, setTime] = useState(new Date());
  const [solicitacoesDeFalaGrandeExp, setSolicitacoesDeFalaGrandeExp] =
    useState({});
  const [apartearGrandeExp, setApartearGrandeExp] = useState({});
  const [isPlayingApartearGrandeExp, setIsPlayingApartearGrandeExp] =
    useState(false);
  const [secondsGrandeExpApartear, setSecondsGrandeExpApartear] = useState(
    3 * 60
  );
  const [secondsGrandeExp, setSecondsGrandeExp] = useState(10 * 60);
  const [isPlayingGrandeExp, setIsPlayingGrandeExp] = useState(false);
  const [presencaParlamentares, setPresencaParlamentares] = useState([]);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          ...data,
        };
      });

      //@ts-ignore
      setPresencaParlamentares(parsedData);
    });
  }, []);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "grande-expediente"
    );
    const queryRef = query(ordersRef, where("status", "==", true), limit(1));
    const queryRef2 = query(
      queryRef,
      where("solicitacao", "==", true),
      limit(1)
    );

    onSnapshot(queryRef2, (querySnapshot) => {
      if (querySnapshot.docs.length != 0) {
        setIsPlayingGrandeExp(true);
      } else {
        setIsPlayingGrandeExp(false);
      }
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPlayingGrandeExp && secondsGrandeExp > 0) {
        setSecondsGrandeExp(secondsGrandeExp - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
    //@ts-ignore
  }, [isPlayingGrandeExp, secondsGrandeExp]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPlayingApartearGrandeExp && secondsGrandeExpApartear > 0) {
        setSecondsGrandeExpApartear(secondsGrandeExpApartear - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
    //@ts-ignore
  }, [isPlayingApartearGrandeExp, secondsGrandeExpApartear]);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "grande-expediente"
    );
    const queryRef = query(
      ordersRef,
      where("solicitacao", "==", true),
      limit(1)
    );

    onSnapshot(queryRef, (querySnapshot) => {
      if (querySnapshot.docs.length != 0) {
        const parsedData = querySnapshot.docs.map(async (docSnapshot) => {
          const data = docSnapshot.data();

          const userDocRef = doc(
            db,
            "users",
            `belacruz@eleg`,
            "parlamentares",
            `${docSnapshot.id}`
          );
          const userDocSnapshot = await getDoc(userDocRef);
          const userDocData = userDocSnapshot.data();
          const userPhoto = userDocData ? userDocData.imageP : "";

          return { id: docSnapshot.id, ...data, imageP: userPhoto };
        });

        // Aguarda todas as consultas dos usuários serem resolvidas
        Promise.all(parsedData).then((parsedDataResolved) => {
          //@ts-ignore
          setSolicitacoesDeFalaGrandeExp(parsedDataResolved[0]);
          //@ts-ignore
          setIsPlayingGrandeExp(parsedDataResolved[0].status);
        });
      } else {
        setSolicitacoesDeFalaGrandeExp({});
        //@ts-ignore
        setIsPlayingGrandeExp(false);
        setSecondsGrandeExp(10 * 60);
      }
    });
  }, []);

  useEffect(() => {
    const db = getFirestore();

    //@ts-ignore
    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "grande-expediente",
      //@ts-ignore
      `${solicitacoesDeFalaGrandeExp.id}`,
      "apartear"
    );
    const queryRef = query(
      ordersRef,
      where("solicitacaoApartear", "==", true),
      limit(1)
    );

    onSnapshot(queryRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          ...data,
          id: doc.id,
        };
      });

      if (parsedData[0] != undefined) {
        //@ts-ignore
        setIsPlayingApartearGrandeExp(parsedData[0].statusApartear);
        setApartearGrandeExp(parsedData[0]);
      } else {
        //@ts-ignore
        setIsPlayingApartearGrandeExp(false);
        setApartearGrandeExp({});
        setSecondsGrandeExpApartear(2 * 60);
      }
    });

    //@ts-ignore
  }, [solicitacoesDeFalaGrandeExp.id]);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (secondsGrandeExp === 0 && isPlayingApartearGrandeExp) {
      //@ts-ignore
      audioRef.current.play();
    }
  }, [secondsGrandeExp, setIsPlayingApartearGrandeExp]);

  //@ts-ignore
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className="min-h-screen flex flex-col justify-between p-0 bg-gray-900">
      <div>
        <Card className="min-w-[100%] h-22 items-center bg-gray-900 p-0 ">
          <CardHeader className="flex flex-col items-center">
            <h1 className="text-5xl font-extrabold  uppercase text-gray-50">
              Câmara Municipal de Bela Cruz
            </h1>
            <Divider className="bg-amber-300 my-2 h-[8px] " />
            <p className="text-3xl font-sans  text-gray-50 uppercase">
              {/* @ts-ignore */}
              {sessao.sessao} SESSÃO{" "}
              {sessao.tipoSessao === "extraordinaria"
                ? "EXTRAORDINÁRIA"
                : "ORDINÁRIA"}{" "}
              {sessao.periodo === undefined
                ? ""
                : sessao.periodo === "1"
                ? "DO 1° PERÍODO DA LEGISLATURA"
                : "DO 2° PERÍODO DA LEGISLATURA"}{" "}
              ({sessao.legislatura})
            </p>
          </CardHeader>
        </Card>
      </div>

      <audio ref={audioRef}>
        <source src={sound} type="audio/mp3" />
      </audio>

      <div className="flex flex-row self-center">
        {
          //@ts-ignore
          apartearGrandeExp.id === undefined &&
            //@ts-ignore
            (solicitacoesDeFalaGrandeExp.id !== undefined ? (
              <div className="mt-6 ">
                <p className="text-4xl font-GeneralSansSemiBold text-gray-50">
                  {/* @ts-ignore */}
                  SOLICITAÇÃO DE FALA - {solicitacoesDeFalaGrandeExp.nome}
                </p>

                <div
                  className={
                    "bg-[linear-gradient(110deg,#151B29,#1E2B47)] flex-row items-center justify-between px-[5rem] flex p-4 mb-6 max-h-[18rem] min-w-[50rem] min-h-[18rem] h-full w-full mt-6 rounded-xl border border-[#2E3648]"
                  }
                >
                  <div className="relative w-[15rem] h-[15rem]">
                    <div className="absolute inset-0 flex justify-center items-center z-10">
                      <div className="bg-gray-200 w-[15rem] h-[15rem] rounded-full p-1">
                        {/* @ts-ignore */}
                        <Avatar
                          className="rounded-full w-full h-full"
                          //@ts-ignore
                          src={solicitacoesDeFalaGrandeExp.imageP}
                        />
                      </div>
                    </div>
                    <div className="absolute inset-0 flex  justify-center items-center z-0">
                      {isPlayingGrandeExp && (
                        <motion.div
                          className="bg-blue-500 w-[15rem] h-[15rem] rounded-full"
                          animate={{
                            scale: [
                              1, 1.1, 1.13, 1.1, 1.12, 1.11, 1.13, 1.12, 1.1, 1,
                            ],
                          }}
                          transition={{ duration: 2.5, repeat: Infinity }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col w-[60%] ml-8 mt-10">
                    <p className="text-3xl mt-4 font-GeneralSansRegular text-gray-50">
                      Tempo de fala:
                    </p>
                    <p className="text-[10rem] -mt-6 font-GeneralSansSemiBold text-gray-50">
                      {formatTime(secondsGrandeExp)}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={
                  "bg-[linear-gradient(110deg,#151B29,#1E2B47)] flex-row items-center justify-between px-[5rem] flex p-4 mb-6 max-h-[18rem] min-w-[50rem] min-h-[18rem] h-full w-full mt-6 rounded-xl border border-[#2E3648]"
                }
              >
                <p className="text-[5rem] font-GeneralSansSemiBold text-gray-50">
                  Aguardando fala.
                </p>
              </div>
            ))
        }

        {
          //@ts-ignore
          apartearGrandeExp.id != undefined && (
            <div className="mt-6">
              <p className="text-4xl font-GeneralSansSemiBold text-gray-50">
                {/* @ts-ignore */}
                SOLICITAÇÃO DE APARTEAR - {apartearGrandeExp.nome}
              </p>

              <div
                className={
                  "bg-[linear-gradient(110deg,#151B29,#1E2B47)] flex-row items-center justify-between px-[5rem] flex p-4 mb-6 max-h-[18rem] min-w-[50rem] min-h-[18rem] h-full w-full mt-6 rounded-xl border border-[#2E3648]"
                }
              >
                <div className="relative w-[15rem] h-[15rem]">
                  <div className="absolute inset-0 flex justify-center items-center z-10">
                    <div className="bg-gray-200 w-[15rem] h-[15rem] rounded-full p-1">
                      {/* @ts-ignore */}
                      <Avatar
                        className="rounded-full w-full h-full"
                        //@ts-ignore
                        src={apartearGrandeExp.imageP}
                      />
                    </div>
                  </div>
                  <div className="absolute inset-0 flex  justify-center items-center z-0">
                    {isPlayingApartearGrandeExp && (
                      <motion.div
                        className="bg-blue-500 w-[15rem] h-[15rem] rounded-full"
                        animate={{
                          scale: [
                            1, 1.1, 1.13, 1.1, 1.12, 1.11, 1.13, 1.12, 1.1, 1,
                          ],
                        }}
                        transition={{ duration: 2.5, repeat: Infinity }}
                      />
                    )}
                  </div>
                </div>
                <div className="flex flex-col w-[60%] ml-8 mt-10">
                  <p className="text-3xl mt-4 font-GeneralSansRegular text-gray-50">
                    Tempo de fala:
                  </p>
                  <p className="text-[10rem] -mt-6 font-GeneralSansSemiBold text-gray-50">
                    {formatTime(secondsGrandeExpApartear)}
                  </p>
                </div>
              </div>
            </div>
          )
        }
      </div>

      <div>
        <Divider className="bg-gray-700 h-[18px]" />

        <div className="grid h-full w-full grid-cols-3 ">
          <div className="flex flex-col h-full">
            <div className="p-1 border-1 border-gray-700 h-full text-5xl text-center font-bold text-gray-50">
              {format(new Date(), "HH:mm:ss")}
            </div>
            <div className="p-1 border-1 border-gray-700 h-full text-2xl text-center font-normal text-gray-50">
              {format(new Date(), "dd/MM/yyyy")}
            </div>
          </div>

          <div className="flex h-full w-full flex-row justify-between">
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                SIM
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full w-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                NÃO
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                ABST
              </div>
            </div>
          </div>

          <div className=" h-full w-full flex flex-col justify-between">
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-white">
              <span className="text-2xl font-semibold ">PARLAMENTARES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length}
              </span>
            </div>
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-red-500">
              <span className="text-2xl font-semibold ">AUSENTES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length -
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length}
              </span>
            </div>
            <div className="p-1 h-full w-full flex flex-row justify-between px-16 border-1 border-slate-600 text-2xl text-center font-normal text-blue-400">
              <span className="text-2xl font-bold ">PRESENTES</span>
              <span className="text-2xl font-bold ">
                {
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
